Namespace 'App'


# z = {}
# y = {children:[z, d, ...]}
# x = {children:[y, c, ...]}
# selectedOptions: [x[valueProperty], y[valueProperty], z[valueProperty]]
# options: [x,a,b]
# options must conform a tree


class App.HierarchicalSelectView extends Backbone.View
  className: 'hierarchical-select'
  template: JST['backbone/templates/monitoring/select/hierarchical']

  defaults:
    selectedOptions: []
    options: []
    placeholders: [] # indicates what placeholder to show on each level, only displays truthy values
    valueProperty: 'value' # option[valueProperty]
    descriptionProperty: 'name' # option[descriptionProperty]
    childrenProperty: 'children' # option[childrenProperty]
    activeProperty: 'active' # option[activeProperty] indicates if a given option should be selectable or not
    allowEmptyProperty: 'allowEmpty' # option[allowEmptyProperty] it indicates if a given option can have no selected child
    allowEmpty: true # indicates if in the top level select should allow to have no selected option
    width: '200px'
    editable: true
    renderCross: false # indicates if chosen elements should render a X besides each of them to unselect
    renderSelected: false # indicates if chosen path should be rendered as tags below selects

  initialize: (@options = {}) ->
    _.defaults(@options, @defaults) #set defaults

  render: =>
    @$el.html(@template())
    @_renderCurrentLevel()
    @_renderRemainingLevels() unless @_isLeaf()
    @_renderSelected() if @options.renderSelected
    @

  _isLeaf: =>
    currentLevelSelectedOption = @_currentLevelSelectedOption()
    !(currentLevelSelectedOption &&
      currentLevelSelectedOption[@options.childrenProperty] &&
      currentLevelSelectedOption[@options.childrenProperty].length)

  _renderCurrentLevel: =>
    $currentLevel = @$el.find('#current-level')

    if @options.allowEmpty && !@options.selectedOptions.length
      $currentLevel.addClass('optional')

    if @options.renderCross
      @_renderCrossWrapper($currentLevel, @_renderCurrentLevelSelect())
    else
      $currentLevel.html(@_renderCurrentLevelSelect())

  _renderCurrentLevelSelect: =>
    selectView = new App.SelectView(@_currentLevelSelectViewOptions())
    @listenTo(selectView, 'change', ($selectedOption) =>
      # This is to give the impression that there is no waiting time
      selectView.changePlaceholder($selectedOption.text())
      # This is used to allow input-select closing itself before proceed
      setTimeout(
        => @_onChange(selectView)
      , 1
      )
    )
    selectView.el

  _renderCrossWrapper: ($currentLevel, selectEl) =>
    crossWrapper = new App.HierarchicalSelect.CrossWrapperView(
      showCross: !!@options.selectedOptions.length
      children: selectEl,
      el: $currentLevel
    )
    @listenToOnce(crossWrapper, 'remove', => @_removeSelection(@options.selectedOptions[0]))
    crossWrapper.render()

  _onChange: (selectView) =>
    @trigger('change', selectView.toArray())

  _currentLevelSelectViewOptions: =>
    selectedOption = @_currentLevelSelectedOption()
    selectedOptions = if selectedOption then [selectedOption] else []
    placeholder = if selectedOption then selectedOption[@options.descriptionProperty] else @options.placeholders[0]
    {
      selectedOptions
      options: _.filter(@_currentLevelOptions(), (option) => option[@options.activeProperty])
      valueProperty: @options.valueProperty
      descriptionProperty: @options.descriptionProperty
      childrenProperty: @options.childrenProperty
      width: @options.width
      editable: @options.editable
      placeholder: placeholder
      showTags: @options.renderSelected
    }

  _currentLevelSelectedOption: =>
    @options.options.find((option) => option[@options.valueProperty] == @options.selectedOptions[0])

  _currentLevelOptions: =>
    @options.options

  _renderRemainingLevels: =>
    hierarchicalSelectView = new App.HierarchicalSelectView(@_remainingLevelsSelectViewOptions())
    @listenTo(hierarchicalSelectView, 'change', @_onChildrenChange)
    hierarchicalSelectView.render().el

  _onChildrenChange: (selected) =>
    @trigger('change', [@options.selectedOptions[0], selected...])

  _remainingLevelsSelectViewOptions: =>
    currentLevelSelectedOption = @_currentLevelSelectedOption()
    options = currentLevelSelectedOption[@options.childrenProperty]
    placeholders = @options.placeholders.slice(1)
    allowEmpty = currentLevelSelectedOption[@options.allowEmptyProperty]
    el = @$el.find('#remaining-levels')
    Object.assign(
      {},
      @options,
      {
        selectedOptions: @options.selectedOptions.slice(1),
        options
        placeholders
        allowEmpty
        renderSelected: false
        el
      }
    )

  _renderSelected: =>
    @$el.find('> #selection').html(
      @_selectedOptions().map(@_label)
    )

  _label: (option) =>
    label = $('<span class="label"><i class="icon-white icon-remove"></i><span></span></span>')
    span = label.children().eq(1)
    text = option[@options.descriptionProperty]
    span.text(text)
    span.prop('title', text)
    label.children().eq(0).click(=> @_removeSelection(option[@options.valueProperty]))
    label

  _selectedOptions: =>
    @_flattenOptions(@options.options)
      .filter((option) => @options.selectedOptions.includes(option[@options.valueProperty]))

  _flattenOptions: (options) =>
    _.flatten([
      options,
      _.flatten(_.map(options, (option) => @_flattenOptions(option[@options.childrenProperty] || [])))
    ])

  _removeSelection: (option) =>
    @trigger('change', @options.selectedOptions.slice(0, @options.selectedOptions.indexOf(option)))

